// function regionScroll() {
//   if ( $("#offers-content").length ) {
//     $(window).ready(function() {
//       $('html, body').animate({
//         scrollTop: $("#offers-content").offset().top - 100
//       }, 1000);
//     })
//   }
// }

function regionScroll() {
  var target = $("#all-offers");
  $("#view-trips").on("click", function () {
    $('html, body').stop().animate({
      scrollTop: target.offset().top
    }, 1000);
  });
}